// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__DW_O_","title":"AfterFrontImage_title__DdiHz"};